import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { useCallback } from 'react';
import { toast } from '@/components/ui/use-toast';
import { useProductDetailPageTranslations } from '@/hooks/useProductDetailPageTranslations';

interface BulkDownloadToolbarProps {
  productId: number;
  selectedIds: number[];
  disabled?: boolean;
  onDownload: () => void;
}

export function BulkDownloadToolbar({
  selectedIds,
  disabled,
  onDownload,
}: BulkDownloadToolbarProps) {
  const i18n = useProductDetailPageTranslations();

  const handleClick = useCallback(() => {
    if (selectedIds.length > 100) {
      toast({
        variant: 'default',
        title: i18n.getProductAssetsText('bulkDownload.largeDownload.title'),
        description: i18n.getProductAssetsText('bulkDownload.largeDownload.description'),
      });
    }
    if (!disabled) onDownload();
  }, [onDownload, disabled, selectedIds, i18n]);

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      disabled={disabled || !selectedIds.length}
      title={i18n.getProductAssetsText('bulkDownload.title')}
      aria-label={i18n.getProductAssetsText('bulkDownload.ariaLabel')}
    >
      <Download className="size-4" />
      <span className="ml-2">{i18n.getProductAssetsText('bulkDownload.buttonText')}</span>
    </Button>
  );
}
